













import _ from 'lodash';
import numeral from 'numeral';
import {Component, Prop, Vue} from 'vue-property-decorator';
import {GoalSettingColumns} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/GoalSettingColumns';
import {
  columnGoalSetting,
  EconomicGroup,
  IEconomicGroupGoalsDetails,
  inputColumnGoalSetting,
  inputManualColumnGoalSetting,
  numberColumnGoalSetting,
  percentColumnGoalSetting,
  percentIndustryColumnGoalSetting
} from '@/modules/business-plan/modules/approval/pages/ford-goal-settings/types';
import {NumberHelper} from '@/utils/number.helper';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';

@Component({
  name: 'TableFooterGoalSettingComponent'
})
export default class TableFooterGoalSettingComponent extends Vue {
  public numeral = numeral;

  @Prop({required: true})
  public columns: GoalSettingColumns;

  @Prop({required: true})
  public economicGroup: EconomicGroup;

  public getDistinctValues(selector: (obj: IEconomicGroupGoalsDetails) => number, isSales = false, families: any = []): Array<number> {
    if (isSales) {
      return  this.sales.map(selector)
    }

    if (families && families.length) {
      return _.uniqWith(this.sales, (arrVal, othVal) => {
        return arrVal.nameSegment === othVal.nameSegment && arrVal.idSaleType === othVal.idSaleType && families.includes(othVal.idFamily);
      }).map(selector);
    }

    return _.uniqWith(this.sales, (arrVal, othVal) => {
      return arrVal.nameSegment === othVal.nameSegment && arrVal.idSaleType === othVal.idSaleType;
    }).map(selector);
  }

  public getDistinctFamilies(selector: (obj: IEconomicGroupGoalsDetails) => number, families: number[]): Array<number> {
    return this.sales.filter(x => !families.includes(x.idFamily)).map(selector);
  }

  public getFormat(col: columnGoalSetting): string {
    const dict = [
      {typeElement: 'number', format: '0,0'},
      {typeElement: 'percent', format: '0.0%'},
    ];
    const {format} = dict.find(x => x.typeElement === col.typeElement) || dict[0];
    return format;
  }

  public getValue(col: columnGoalSetting): string | number {
    let result: number;
    if ((col as inputManualColumnGoalSetting).isManualInput)
      return '';

    if ((col as numberColumnGoalSetting).getterValue) {
      if ((col as numberColumnGoalSetting).distinctValues && (col as numberColumnGoalSetting).distinctByFamilies.length) {
        return Array.from(this.getDistinctFamilies((col as numberColumnGoalSetting).getterValue, (col as numberColumnGoalSetting).distinctByFamilies)).sum();
      }

      if ((col as numberColumnGoalSetting).distinctValues) {
        return Array.from(this.getDistinctValues((col as numberColumnGoalSetting).getterValue)).sum();
      }

      return this.sales.sumBy((col as numberColumnGoalSetting).getterValue);
    }

    if ((col as percentIndustryColumnGoalSetting).getterOver && !(col as percentIndustryColumnGoalSetting).withSubtract) {
      let value = col as percentIndustryColumnGoalSetting;
      const total = Array.from(this.getDistinctValues(value.getterIndustryTotal, false, value.distinctByFamilies)).sum();
      const over = Array.from(this.getDistinctValues(value.getterOver, true)).sum();

      result = over / total;
      return result;
    }

    if ((col as percentColumnGoalSetting).getterOver) {
      const value = col as percentColumnGoalSetting;

      if (value.withSubtract) {
        const sumIndustryNextYear = Array.from(this.getDistinctValues(value.getterTotal, false, value.distinctByFamilies)).sum();
        const sumIndustryLastYear = Array.from(this.getDistinctValues(value.getterOver, false, value.distinctByFamilies)).sum();

        if (sumIndustryLastYear === 0) {
          return numeral(0).format('0.0%');
        }

        const total = (sumIndustryNextYear / sumIndustryLastYear) - 1;

        return numeral(total).format('0.0%');
      }

      if (value.getterOver) {
        const total = Array.from(this.getDistinctValues(value.getterTotal)).sum();
        const over = this.sales.sumBy(value.getterOver);

        result = over / total;

        return result;
      }
    }

    return '';
  }

  public getShareInput(col: inputColumnGoalSetting): string {
    if ((col as inputManualColumnGoalSetting).isManualInput)
      return '';

    console.log(col.distinctByFamilies);

    const total = this.getDistinctValues(this.columns.getInputShareTotalProp, false, col.distinctByFamilies).sum();
    const over = this.sales.sumBy(col.getterValue);

    return NumberHelper.percent(total, over);
  }

  public get sales(): IEconomicGroupGoalsDetails[] {
    const saleType = this.columns.saleType.value;
    return this.economicGroup.details.filter(x => saleType === x.idSaleType || saleType === SaleTypeEnum.AllOfIt);
  }
}
